import { FormattedMessage, useIntl } from "react-intl";

type Props = {
  label?: string;
  hint?: string;
  // Friendly "coming soon" treatment for features that aren't wired to a
  // backend yet (vs. the default, which marks a genuinely empty/no-data
  // state). Shows a blurred faux-content field + a "coming soon" badge.
  comingSoon?: boolean;
};

export function NoBackend({ label, hint, comingSoon = false }: Props) {
  const intl = useIntl();
  const resolvedLabel =
    label ?? intl.formatMessage({ id: "common.noBackend", defaultMessage: "No backend endpoint" });
  if (comingSoon) {
    return (
      <div className="relative overflow-hidden rounded-md bg-ink/[0.02] px-4 py-7 ring-1 ring-ink/10">
        {/* Blurred skeleton hinting at the content that's on the way. */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-2 opacity-50 blur-[5px]"
        >
          <div className="h-2.5 w-2/3 rounded-full bg-ink/10" />
          <div className="h-2.5 w-1/2 rounded-full bg-ink/10" />
          <div className="h-2.5 w-3/5 rounded-full bg-ink/10" />
        </div>
        <div className="relative flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent/10 px-2.5 py-0.5 text-[9px] font-semibold tracking-[0.18em] text-accent">
            <FormattedMessage id="common.comingSoon" defaultMessage="Coming soon" />
          </span>
          <div className="mt-2 text-[12px] font-medium text-ink/70">{resolvedLabel}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-md bg-ink/[0.02] px-4 py-6 text-center ring-1 ring-ink/15">
      <div className="text-[12px] text-ink/55">{resolvedLabel}</div>
      {hint ? <div className="mt-1 text-[11px] text-ink/40">{hint}</div> : null}
    </div>
  );
}
